import styled, { css } from "styled-components";

export {
	SectionCard,
	SectionHeader,
	SectionTitle,
	ControlsPanel,
	ControlsRow,
	ContentDivider,
} from "../../elements";

export const PendingBanner = styled.div`
	display: flex;
	align-items: center;
	min-height: 40px;
	padding: 10px 16px;
	border-radius: 25px;
	border: 1px solid var(--main-color);
	background: rgba(11, 6, 16, 0.6);
	color: var(--main-color);
	font-size: 12px;
	font-weight: 600;
	line-height: 18px;
	letter-spacing: 0.3px;
	text-align: center;

	${window.HAS_LESS_BORDER_RADIUS &&
	css`
		border-radius: 10px;
	`}
`;

export const BackofficeHint = styled.div`
	padding: 10px 14px;
	border-radius: 12px;
	background: var(--main-explosive-opacity-05, rgba(110, 113, 145, 0.08));
	border: 1px solid var(--main-color-light, var(--main-color));
	color: var(--secondary-text-color);
	font-size: 12px;
	line-height: 18px;
	letter-spacing: 0.25px;
`;

export const MessagesArea = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	min-height: 0;
`;

export const MessageSlot = styled.div`
	display: ${({ $visible }) => ($visible ? "block" : "none")};
`;

export const RemoveButtonSlot = styled.div`
	min-height: 40px;

	button[aria-hidden="true"] {
		visibility: hidden;
		pointer-events: none;
	}
`;

export const FormWrapper = styled.div`
	width: 100%;

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type="number"] {
		-moz-appearance: textfield;
		appearance: textfield;
	}

	.ant-input {
		color: var(--content-text-color) !important;
		font-size: 12px !important;
		font-weight: 400 !important;
		line-height: 16px !important;
		letter-spacing: 0.3px !important;
		width: 100%;
		height: 40px;
		padding: 10px 5px 0 20px !important;
		border-radius: 50px;
		border: 1px solid var(--profile-card-text-color);
		background: var(--input-bg-has-value) !important;
	}

	.ant-input[disabled] {
		border: 1px solid var(--profile-card-text-color) !important;
		opacity: 0.6;
	}

	.ant-form-item {
		margin-bottom: 0;
		position: relative;

		.ant-form-item-label {
			position: absolute;
			z-index: 1;
			top: 5px;
			left: 21px;
			height: 12px;
			display: flex;
			align-items: center;

			& > label {
				color: var(--main-secondary-text-color);
				font-size: 10px;
				font-weight: 400;
				line-height: 12px;
				letter-spacing: 0.25px;
				height: 100%;
			}
		}
	}

	.two-factor-auth-exclude-btn {
		display: flex;
		width: 100%;
		min-height: 40px;
		justify-content: center;
		align-items: center;
		border-radius: 25px;
		background: var(--main-gradient, var(--profile-card-button-bg));
		color: var(--button-color, #fff);
		font-size: 12px;
		font-weight: 700;
		line-height: 20px;
		letter-spacing: 0.5px;
		text-transform: uppercase;
		border: none;
		opacity: 1;

		${window.HAS_LESS_BORDER_RADIUS &&
		css`
			border-radius: 10px;
		`}
	}

	.ant-btn[disabled],
	.ant-btn[disabled]:hover,
	.ant-btn[disabled]:focus,
	.ant-btn[disabled]:active {
		background: var(--profile-card-button-bg);
		color: var(--button-color);
		opacity: 0.35;
	}
`;

export const RemoveButton = styled.button`
	display: flex;
	width: 100%;
	min-height: 40px;
	justify-content: center;
	align-items: center;
	border-radius: 25px;
	background: transparent;
	border: 1px solid var(--main-color-light, var(--main-color));
	color: var(--main-color);
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	cursor: pointer;
	transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;

	${window.HAS_LESS_BORDER_RADIUS &&
	css`
		border-radius: 10px;
	`}

	&:hover:not(:disabled) {
		color: var(--button-color, #fff);
		background: var(--main-gradient, var(--main-color));
		border-color: transparent;
	}

	&:disabled {
		opacity: 0.4;
		cursor: not-allowed;
	}
`;

export const ErrorText = styled.div`
	color: var(--main-color-light, #fca5a5);
	font-size: 12px;
	line-height: 18px;
	letter-spacing: 0.25px;
`;
